export default {
  noBodyScroll: 'vd-body--no-scroll',
}
